<app-ace-select
  #aceSelect
  [items]="options"
  [bindLabel]="'name_key'"
  [placeholder]="placeholder | messageTranslate"
  [loading]="loading"
  [hideSelected]="hideSelected"
  [appendTo]="appendTo"
  [clearable]="false">

  <ng-template #optionTemplate #labelTemplate let-item="item">
    <span class="ng-value-label">{{item.name_key | messageTranslate}}</span>
  </ng-template>

</app-ace-select>
